export const CAMPOS_DE_DATA = [
  'dt_protocolo_cobranca',
  'dt_processamento',
  'dt_pagto',
  'dt_geracao_retorno',
  'dt_solicitacao',
  'dt_autorizacao',
  'dt_realizacao',
  'dt_nascimento',
];

// Campos que devem ser mapeados para seus respectivos domínios
export const DOMINIOS_MAPEADOS: Record<string, string> = {
  tp_registro: 'dm_statusTransacaoMonitor',
  tp_guia: 'MON_TIPO_GUIA',
  id_origem_guia: 'dm_origemEventoAtencaoSaude',
  id_situacao_registro: 'MON_REGISTRO_SITUACAO',
  id_cnpj_cpf_exec: 'MON_ID_CNPJ_CPF',
  id_forma_envio_exec: 'dm_formaEnvio',
  tp_atendimento: 'dm_tipoAtendimento',
  id_regime_atendimento: 'dm_regimeAtendimento',
  tp_consulta: 'dm_tipoConsulta',
  id_carater_atendimento: 'dm_caraterMonitoramento',
  id_acidente: 'dm_indicadorAcidente',
  id_sexo: 'dm_sexo',
};

// Mapeia os nomes dos campos retornados pela API para rótulos mais legíveis na interface
export const CAMPO_ALIASES: Readonly<Record<string, string>> = {
  cd_guia_monitor: 'Cód. lancto',
  nr_competencia: '003-Competência',
  cd_guia_monitor_inclusao: 'Cód. lancto inclusão',
  tp_registro: '009-Tipo de registro',
  nr_lote: '002-Número do lote',
  dt_processamento: '080-Data Processamento',
  dt_pagto: '033-Data pagamento',
  dt_geracao_retorno: 'Processamento pela ANS',
  vl_processado: '051-Valor processado da guia',
  vl_glosa: '117-Valor total de glosa',
  vl_pago: '059-Valor total pago',
  nr_guia_operadora: '024-Nr. guia na operadora',
  nr_guia_prestador: '023-Nr. guia no prestador',
  nr_reembolso: '025-Nr. reembolso ou pagto eventual',
  tp_guia: '021-Tipo de guia',
  id_situacao_registro: 'Situação registro',
  id_origem_guia: '022-Origem da guia',
  dt_protocolo_cobranca: '032-Data protocolo cobrança',
  id_cnpj_cpf_exec: '013-Tipo docto - CNPJ ou CPF',
  nr_cnpj_cpf_exec: '014-CNPJ/CPF executante',
  nr_cnes_exec: '012-CNES executante',
  id_versao_tiss_exec: '010-Padrão do prestador',
  id_forma_envio_exec: '011-Indicador da forma de envio',
  cd_municipio_exec: '015-Município executante',
  tp_atendimento: '045-Tipo de atendimento',
  id_regime_atendimento: '123-Regime de atendimento',
  id_saude_ocupacional: '124-Saúde ocupacional',
  tp_consulta: '034-Tipo de consulta',
  nr_cbo_exec: '035-CBO do executante',
  ib_recem_nato: '036-Atendimento ao recém-nato',
  id_carater_atendimento: '038-Caráter do atendimento',
  id_motivo_saida: '049-Motivo encerramento',
  id_acidente: '037-Acidente ou doença relacionada?',
  dt_solicitacao: '027-Data solicitação',
  dt_autorizacao: '028-Data autorização',
  dt_realizacao: '029-Data realização ou início do atendimento',
  nr_cpf_beneficiario: '121-CPF do beneficiário',
  nr_registro_plano: '020-Nr. plano na ANS',
  id_sexo: '017-Sexo do beneficiário',
  dt_nascimento: '018-Data nascimento',
  cd_municipio: '019-Município do beneficiário',
  nr_guia_solicitacao_internacao: '026-Nr. guia de solicitação de internação',
  nr_guia_principal: '083-Nr. guia principal SP/SADT ou odonto',
  nr_contrato_valor_pre: '082-Nr. contrato valor pré',
  nr_registro_ans_intermediaria: '081-Registro ANS da OPS intermediária',
  tp_atendimento_intermediaria: '120-Tipo de atendimento por OPS intermediária',
  vl_guia_informado: '050-Valor informado da guia',
  ib_existe_mon_guia: 'Descartado?',
};

// Mapeia cada campo ao grupo ao qual ele pertence na visualização
export const GRUPOS_MOCK = {
  cd_guia_monitor: 'Guia',
  nr_competencia: 'Guia',
  tp_registro: 'Guia',
  cd_guia_monitor_inclusao: 'Guia',
  nr_lote: 'Guia',
  nr_guia_operadora: 'Guia',
  nr_guia_prestador: 'Guia',
  nr_reembolso: 'Guia',
  tp_guia: 'Guia',
  id_origem_guia: 'Guia',
  id_situacao_registro: 'Guia',
  dt_protocolo_cobranca: 'Processamento',
  dt_processamento: 'Processamento',
  dt_pagto: 'Processamento',
  dt_geracao_retorno: 'Processamento',
  id_cnpj_cpf_exec: 'Prestador executante',
  nr_cnpj_cpf_exec: 'Prestador executante',
  id_versao_tiss_exec: 'Prestador executante',
  id_forma_envio_exec: 'Prestador executante',
  cd_municipio_exec: 'Prestador executante',
  tp_atendimento: 'Dados do atendimento',
  id_regime_atendimento: 'Dados do atendimento',
  id_saude_ocupacional: 'Dados do atendimento',
  tp_consulta: 'Dados do atendimento',
  nr_cbo_exec: 'Dados do atendimento',
  ib_recem_nato: 'Dados do atendimento',
  id_carater_atendimento: 'Dados do atendimento',
  id_motivo_saida: 'Dados do atendimento',
  id_acidente: 'Dados do atendimento',
  dt_solicitacao: 'Dados do atendimento',
  dt_autorizacao: 'Dados do atendimento',
  dt_realizacao: 'Dados do atendimento',
  nr_cnes_exec: 'Dados do beneficiário',
  nr_cpf_beneficiario: 'Dados do beneficiário',
  nr_registro_plano: 'Dados do beneficiário',
  id_sexo: 'Dados do beneficiário',
  dt_nascimento: 'Dados do beneficiário',
  cd_municipio: 'Dados do beneficiário',
  nr_guia_solicitacao_internacao: 'Vínculos da guia',
  nr_guia_principal: 'Vínculos da guia',
  nr_contrato_valor_pre: 'Vínculos da guia',
  nr_registro_ans_intermediaria: 'Vínculos da guia',
  tp_atendimento_intermediaria: 'Vínculos da guia',
  vl_guia_informado: 'Valores',
  vl_processado: 'Valores',
  vl_glosa: 'Valores',
  vl_pago: 'Valores',
};

// lista dos campos utilizados na transformação dos dados
export const CAMPOS = [
  'cd_guia_monitor',
  'nr_competencia',
  'tp_registro',
  'cd_guia_monitor_inclusao',
  'nr_lote',
  'nr_guia_operadora',
  'nr_guia_prestador',
  'nr_reembolso',
  'tp_guia',
  'id_origem_guia',
  'id_situacao_registro',
  'dt_protocolo_cobranca',
  'dt_processamento',
  'dt_pagto',
  'dt_geracao_retorno',
  'id_cnpj_cpf_exec',
  'nr_cnpj_cpf_exec',
  'nr_cnes_exec',
  'id_versao_tiss_exec',
  'id_forma_envio_exec',
  'cd_municipio_exec',
  'tp_atendimento',
  'id_regime_atendimento',
  'id_saude_ocupacional',
  'tp_consulta',
  'nr_cbo_exec',
  'ib_recem_nato',
  'id_carater_atendimento',
  'id_motivo_saida',
  'id_acidente',
  'dt_solicitacao',
  'dt_autorizacao',
  'dt_realizacao',
  'nr_cpf_beneficiario',
  'nr_registro_plano',
  'id_sexo',
  'dt_nascimento',
  'cd_municipio',
  'nr_guia_solicitacao_internacao',
  'nr_guia_principal',
  'nr_contrato_valor_pre',
  'nr_registro_ans_intermediaria',
  'tp_atendimento_intermediaria',
  'vl_guia_informado',
  'vl_processado',
  'vl_glosa',
  'vl_pago',
  'ib_existe_mon_guia',
];
